import Cookies from 'js-cookie';
import { _api } from './apiAxios';
import Vue from 'vue';

export function postData(userId) {
  const gestrkSubId = Cookies.get('gestrkSubId');
  if (gestrkSubId && userId) {
    _api.get('https://go.gestrk.com/postback', {
      params: {
        cid: gestrkSubId,
        txid: userId,
        et: 'deposit',
      },
    });
  }
}

Vue.prototype.$gestrk = {
  postData,
};
